var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tagName,{tag:"component",staticClass:"isolate flex cursor-pointer flex-row items-center gap-x-2 border-b-[2px] px-1 pb-2 text-sm font-semibold leading-6 transition-all duration-150 hover:border-slate-800 hover:text-slate-800",class:[
        { 'border-slate-800 bg-transparent text-slate-800': _vm.active },
        {
            'border-b-transparent bg-transparent text-slate-500': !_vm.active,
        },
    ],attrs:{"disabled":_vm.disabled,"href":_vm.href,"title":_vm.title,"type":_vm.buttonType,"to":_vm.to},on:{"click":_vm.onClick}},[(_vm.icon)?_c('Icon',{staticClass:"size-4",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.$t("navigation." + _vm.title))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }